<style lang="less">
  @import "./login.less";
</style>

<template>
  <div class="login">
    <div class="login-con">
      <Card icon="log-in" title="欢迎登录人力资源市场智能求职系统" :bordered="false">
        <div class="form-con">
<!--          <login-form :secoundAuth=secoundAuth @on-success-valid="handleSubmit"></login-form>-->

          <Button @click="wxsubmit" type="success" long>登录</Button>
          <Divider orientation="left"></Divider>
          <Row>
<!--            <Col span="12"> <Button @click="regsubmit" type="text" size="small">注册</Button></Col>-->
<!--            <Col span="12"> <Button @click="regsubmit" type="text" size="small">忘记密码</Button></Col>-->
          </Row>

        </div>
      </Card>
    </div>
    <Modal v-model="modalVisible"  :title="modalTitle" :loading=true :footer-hide=true :mask-closable=false width="360">
      <slide-verify ref="slideblock"
                    @success="onSuccess"
                    @fail="onFail"
                    @refresh="onRefresh"
                    :slider-text="text"
                    :imgs="imgs"
      ></slide-verify>

    </Modal>
<!--    <Modal v-model="regmodalVisible"  title="用户注册" :loading=true :footer-hide=true :mask-closable=false>-->
<!--      <register-form :mail="mail" :username='username' ></register-form>-->
<!--    </Modal>-->
    <Modal v-model="bindmodalVisible"  title="用户绑定" :loading=true :footer-hide=true :mask-closable=false>
      <login-form :secoundAuth=secoundAuth @on-success-valid="handleSubmit"></login-form>
    </Modal>
    <Modal v-model="wxmodalVisible"  title="微信登录" :loading=true :footer-hide=true :mask-closable=false width="360">
      <iframe
        src="https://open.weixin.qq.com/connect/qrconnect?appid=wxdc747dd1a568d53b&redirect_uri=https%3A%2F%2Fljtc.tcrc.com.cn%2Flogin&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
        frameborder="0"
        width="100%"
        height="400px"
        scrolling="auto"
      ></iframe>

    </Modal>
  </div>
</template>

<script>
  import { LoginForm, RegisterForm } from '_c/login-form'
  import { login_w, login_wx } from '@/api/user'

  import img1 from '@/assets/images/1.jpg'
  import img2 from '@/assets/images/2.jpg'
  import img3 from '@/assets/images/3.jpg'
  import img4 from '@/assets/images/4.jpg'

  export default {
    components: {
      LoginForm,
      RegisterForm
    },
    data () {
      return {
        secoundAuth: false,
        modalVisible: false,
        wxmodalVisible: true,
        regmodalVisible: false,
        bindmodalVisible: false,
        openid: '',
        modalTitle: '',
        mail: '',
        username: '',
        mfa: '',
        msg: '',
        text: '向右滑',
        imgs: [
          img1,
          img2,
          img3,
          img4
        ],
        password: '',
        url_now: ''
      }
    },

    methods: {
      onSuccess () {
        // this.msg = 'login success'
        this.modalVisible = false
        let putdata = {
          username: this.username,
          password: this.password,
          dynamic: window.location.href,
          openid: this.openid
        }
        login_w(putdata).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            sessionStorage.setItem('sbid', res.data.sbid)
            // 写入 token 与用户信息，避免路由守卫拦截
            this.$store.commit('setToken', res.data.auth_key)
            this.$store.commit('setUserName', res.data.username)
            this.$store.commit('setNickName', res.data.nickname)
            if (res.data.uid) this.$store.commit('setUserId', res.data.uid)
            this.$router.push({
              name: res.data.fpage || this.$config.homeName
            })
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      },
      login_wx (code) {
        this.openid = ''
        login_wx(code).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            console.log(res.data.fpage)
            // 写入 token 与用户信息，避免路由守卫拦截
            this.$store.commit('setToken', res.data.auth_key)
            this.$store.commit('setUserName', res.data.username)
            this.$store.commit('setNickName', res.data.nickname)
            if (res.data.uid) this.$store.commit('setUserId', res.data.uid)
            this.$router.push({
              name: res.data.fpage || this.$config.homeName
            })
          } else {
            this.$Message.error(`${res.data.msg}`)
            if (res.data.code === 2) {
              this.bindmodalVisible = true
              this.openid = res.data.openid
            }
          }
        })
      },

      onFail () {
        this.msg = ''
      },
      onRefresh () {
        this.msg = ''
      },

      handleSubmit ({ username, password }) {
        this.username = username
        this.password = password
        this.$refs.slideblock.reset()
        this.modalVisible = true
      },
      wxsubmit () {
        this.wxmodalVisible = true
      },
      regsubmit () {
        this.regmodalVisible = true
      },
      IEVersion () {
        // console.log('1')
        var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
        console.log(userAgent)
        var isChrome = userAgent.indexOf('Chrome') > -1
        var isFirefox = userAgent.indexOf('Firefox') > -1
        var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 // 判断是否IE<11浏览器
        var isEdge = userAgent.indexOf('Edge') > -1 && !isIE // 判断是否IE的Edge浏览器
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
        if (isChrome || isFirefox) {
          return -1
        } else {
          return 1
        }
        // if(isIE) {
        //   var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        //   reIE.test(userAgent);
        //   var fIEVersion = parseFloat(RegExp["$1"]);
        //   if(fIEVersion == 7) {
        //     return 7;
        //   } else if(fIEVersion == 8) {
        //     return 8;
        //   } else if(fIEVersion == 9) {
        //     return 9;
        //   } else if(fIEVersion == 10) {
        //     return 10;
        //   } else {
        //     return 6;//IE版本<=7
        //   }
        // } else if(isEdge) {
        //   return 'edge';//edge
        // } else if(isIE11) {
        //   return 11; //IE11
        // }else{
        //   return -1;//不是ie浏览器
        // }
      },
      openGoogle () {
        if (this.IEVersion() == -1) {
          return false
        }
        try {
          var osh = new ActiveXObject('WScript.Shell')
          var p_app_path = osh.RegRead('HKEY_LOCAL_MACHINE\\SOFTWARE\\Microsoft\\Windows\\CurrentVersion\\App Paths\\chrome.exe\\')
          var oShell = new ActiveXObject('Shell.Application')
          var website = 'https://ljtc.tcrc.com.cn' // 项目实际地址
          oShell.ShellExecute(p_app_path, website, '', 'open', '1')
          window.location.href = 'https://ljtc.tcrc.com.cn/tips.html' // 服务器更目录放置的展示页面
        } catch (e) {
          // var ele = document.getElementsByName('error')[0]
          // ele.style.display = 'block'
          window.location.href = 'https://ljtc.tcrc.com.cn/tips.html' // 服务器更目录放置的展示页面
        }
      }

    },
    mounted () {
      // this.openGoogle();
      var query = this.$route.query
      let code = query.code
      let putdata = {
        code: code
      }
      if (code) {
        this.login_wx(putdata)
      }
    }
  }
</script>

<style>
</style>
